// The DSN the tunnel route matches envelopes against, and the tunnel path the browser SDK, the middleware and
// the route share. The DSN is the shared `web` project's (`@agilix/ui/webSentry`): the browser SDK stamps it
// into every envelope header through `webSentryClientOptions`, and the route accepts an envelope only when
// that header names this exact string.
//
// Kept apart from sentryTunnel.ts so that importing it into sentry.client.config.ts does not pull the route's
// parsing code into the page bundle.

export { SENTRY_WEB_DSN as SENTRY_DSN } from '@agilix/ui/webSentry'

// Must match the filename of the route that serves it (src/pages/api/monitoring.ts). The path deliberately
// avoids the word "sentry" - blocker lists match on it, which would defeat the point of tunneling.
export const SENTRY_TUNNEL_PATH = '/api/monitoring'
